import PageLayout from 'components/layout/PageLayout'
import PageLayoutContentOnly from 'components/layout/PageLayoutContentOnly'
import SettingsPageLayout from 'components/layout/SettingsPageLayout'
import InboxPageLayout from 'components/layout/InboxPageLayout'

export const PAGE_LAYOUT = {
  DEFAULT: 'PageLayout',
  CONTENT_ONLY: 'PageLayoutContentOnly',
  SETTINGS: 'SettingsPageLayout',
  INBOX: 'InboxPageLayout',
}

export const PAGE_LAYOUT_TO_COMPONENT_MAP = {
  [PAGE_LAYOUT.DEFAULT]: PageLayout,
  [PAGE_LAYOUT.CONTENT_ONLY]: PageLayoutContentOnly,
  [PAGE_LAYOUT.SETTINGS]: SettingsPageLayout,
  [PAGE_LAYOUT.INBOX]: InboxPageLayout,
}

/**
 * Based on Component.layout will return matching layout component.
 * Defaults to PAGE_LAYOUT.DEFAULT if not match is found.
 * @param {string} layout - a valid PAGE_LAYOUT type
 */
export const getLayoutForPage = (Component) => {
  const layout = Component?.layout
  const LayoutComponent =
    PAGE_LAYOUT_TO_COMPONENT_MAP[layout] || PAGE_LAYOUT_TO_COMPONENT_MAP[PAGE_LAYOUT.DEFAULT]
  return LayoutComponent
}
